export default "__VITE_ASSET__4ug6l5YY__"